import goalDialogReducer from './goalDialogReducer';

export default goalDialogReducer;